import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

const NotFound: React.FC = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-gray-900">
          <FormattedMessage id="notFound.heading" defaultMessage="Page not found" />
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          <FormattedMessage id="notFound.body" defaultMessage="The page you're looking for doesn't exist." />
        </p>
        <div className="mt-4">
          <Link className="text-sm font-medium text-blue-600 hover:text-blue-700" to="/home">
            <FormattedMessage id="notFound.cta" defaultMessage="Go to home" />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
